var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InformationCircle } from '@web/components/layout/InformationCircle/InformationCircle';
import Loading from '@web/components/layout/Loading';
import Pagination from '@web/components/layout/Pagination/Pagination';
import { ActivityHeatmap } from '@web/components/PerformanceReview/Employee/Sections/DailyTimeline/ActivityHeatmap';
import { DailyTimeline } from '@web/components/PerformanceReview/Employee/Sections/DailyTimeline/DailyTimeline';
import { ACTIVITY_COLORS, PAGINATION_PAGE_SIZE } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { getLimitOffset } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { ApplicationEnum } from '@workalizer/shared/enums';
import { eachDayOfInterval, format, isSameDay, parse } from 'date-fns';
import { useTranslation } from 'react-i18next';
var DAILY_TIMELINE_LEGEND_TYPES = [
    ApplicationEnum.CALENDAR,
    ApplicationEnum.MEET,
    ApplicationEnum.CHAT,
    ApplicationEnum.DRIVE,
    ApplicationEnum.GMAIL,
    ApplicationEnum.GEMINI
];
export var DailyTimelineSection = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId;
    var t = useTranslation().t;
    var _b = useFilters(), dateFrom = _b.dateFrom, dateTo = _b.dateTo, page = _b.page;
    var startDate = parse(dateFrom, 'yyyy-MM-dd', new Date());
    var endDate = parse(dateTo, 'yyyy-MM-dd', new Date());
    var allDays = eachDayOfInterval({
        start: startDate,
        end: endDate
    });
    var currentPage = page || 1;
    var _c = getLimitOffset(currentPage, PAGINATION_PAGE_SIZE), limit = _c.limit, offset = _c.offset;
    var paginatedDays = allDays.slice(offset, offset + limit);
    var firstDay = paginatedDays[0];
    var lastDay = paginatedDays[paginatedDays.length - 1];
    var pageDateFrom = firstDay ? format(firstDay, 'yyyy-MM-dd') : dateFrom;
    var pageDateTo = lastDay ? format(lastDay, 'yyyy-MM-dd') : dateTo;
    var timelineData = trpc.userTimeline.useQuery({
        userId: userId,
        dateFrom: pageDateFrom,
        dateTo: pageDateTo
    }, {
        enabled: !!userId && paginatedDays.length > 0
    });
    var eventsByDay = new Map();
    if (timelineData.data) {
        paginatedDays.forEach(function (day) {
            var dayKey = format(day, 'yyyy-MM-dd');
            var dayEvents = timelineData.data.filter(function (event) {
                var eventDate = new Date(event.date);
                return isSameDay(eventDate, day);
            });
            eventsByDay.set(dayKey, dayEvents);
        });
    }
    return (_jsxs("div", __assign({ className: "flex flex-col gap-20 mt-4" }, { children: [_jsx(ActivityHeatmap, { userId: userId, orgUnitId: orgUnitId }), userId && (_jsxs("div", { children: [_jsx("div", __assign({ className: "mx-2 mb-4 flex items-center gap-2" }, { children: _jsxs("div", __assign({ className: "mx-2 flex items-center gap-2" }, { children: [_jsx("h3", __assign({ className: "text-xl font-semibold" }, { children: t('app.performanceReview.employeePerformanceReview.dailyTimelineSection.activityTimeline') })), _jsx(InformationCircle, { text: t('widgetTitleDescriptions.dailyTimeline.activityTimeline') })] })) })), timelineData.isLoading || !timelineData.data ? (_jsx(Loading, {})) : (_jsxs("div", __assign({ className: "space-y-6" }, { children: [_jsx("div", __assign({ className: "ml-2 flex flex-wrap items-center gap-x-6 gap-y-2 pb-2" }, { children: DAILY_TIMELINE_LEGEND_TYPES.map(function (type) { return (_jsxs("div", __assign({ className: "flex items-center gap-2 text-sm text-gray-700" }, { children: [_jsx("div", { className: "h-4 w-4 rounded-md bg-".concat(ACTIVITY_COLORS[type].color), "aria-hidden": true }), _jsx("span", { children: t("app.workPatterns.timeline.legend.".concat(type)) })] }), type)); }) })), paginatedDays.map(function (day) {
                                var dayDateFrom = format(day, 'yyyy-MM-dd');
                                var dayDateTo = format(day, 'yyyy-MM-dd');
                                var dayEvents = eventsByDay.get(dayDateFrom) || [];
                                return (_jsx("div", __assign({ style: { position: 'relative', zIndex: 1 }, onMouseEnter: function (e) {
                                        e.currentTarget.style.zIndex = '100';
                                    }, onMouseLeave: function (e) {
                                        e.currentTarget.style.zIndex = '1';
                                    } }, { children: _jsx(DailyTimeline, { userId: userId, dateFrom: dayDateFrom, dateTo: dayDateTo, events: dayEvents }) }), dayDateFrom));
                            }), allDays.length > PAGINATION_PAGE_SIZE && (_jsx(Pagination, { typeResultText: "days", displayElements: paginatedDays.length, total: allDays.length, pageSize: PAGINATION_PAGE_SIZE }))] })))] }))] })));
};
